module.exports = "/_next/static/files/e7246bbcd7a332de25db526509c875e6.png";